import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

import { ADV_QUERY_FIELD_GROUPS, ADV_QUERY_OPERATORS, QueryField, QueryFieldGroup } from "@/app-data/patent-query";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { CondItem, CondObject } from "@/types";
import { CondOperator } from "@/app-data/enum";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvSearch',
  props: {
  condition: { type: String, default: () => "" },
  appendFields: { type: Array, default: () => [] as Array<QueryField> },
},
  setup(__props, { expose }) {

const props = __props;



const store = useStore();

const defineConds = ref<Array<CondItem>>([]);

const condRelation = ref("");

const initCondObjectCount = 3;

const fieldTypeMap = computed(() => {
  const fieldTypeMap = new Map<string, QueryField>();
  allFields.value.forEach((fieldGroup: QueryFieldGroup) => {
    fieldGroup.fields.forEach((field: QueryField) => fieldTypeMap.set(field.name, field));
  });
  return fieldTypeMap;
});

const allFields = computed(() => {
  const defFields: Array<QueryFieldGroup> = JSON.parse(JSON.stringify(ADV_QUERY_FIELD_GROUPS));
  if (props.appendFields && props.appendFields.length) {
    defFields.push(...JSON.parse(JSON.stringify(props.appendFields)));
  }
  return defFields;
});

const groupedFields = computed(() => allFields.value);

const condOpers = CondOperator;

if (!isEmptyOrWhiteSpace(props.condition)) {
  const cond: CondObject = JSON.parse(props.condition);
  const conds = cond.items || [];
  conds.forEach((item) => {
    const field = fieldTypeMap.value.get(item.name);
    if (!field) {
      return;
    }
    if (field.type === "date") {
      // 只有区间条件回填为数组，单日期的 早于/晚于 必须保持字符串，否则日期控件显示为空
      item.value1 = item.operator === CondOperator.BETWEEN ? [item.value1, item.value2] : item.value1;
      item.value2 = "";
    } else if (field.type === "enum") {
      item.value1 = (item.value1 || "").split(",");
      item.value2 = "";
    } else if (field.type === "tree") {
      item.value1 = (item.value1 || "").split(",").map((value: string) => value.split("/"));
      item.value2 = "";
    }
  });
  if (conds.length < initCondObjectCount) {
    while (conds.length < initCondObjectCount) {
      conds.push({ name: "", operator: "", value1: "", value2: "" });
    }
  }
  defineConds.value = conds;
  condRelation.value = cond.relation || "";
} else {
  for (let i = 0; i < initCondObjectCount; i++) {
    defineConds.value.push({ name: "", operator: "", value1: "", value2: "" });
  }
}

const getCondOperators = (fieldName: string) => {
  if (isEmptyOrWhiteSpace(fieldName)) {
    return [];
  }
  const item = fieldTypeMap.value.get(fieldName);
  if (!item) {
    return [];
  }
  return (ADV_QUERY_OPERATORS as any)[item.type];
};

const getFieldType = (fieldName: string) => {
  const item = fieldTypeMap.value.get(fieldName);
  return item ? item.type : "";
};

const getEnumData = (fieldName: string) => {
  const item = fieldTypeMap.value.get(fieldName);
  if (!item) {
    return [];
  }
  if (!isEmptyOrWhiteSpace(item.enumKey)) {
    return store.getters["enums/getEnumsByKey"](item.enumKey).map((item: any) => [item.label, item.enumValue]);
  }
  if (item.enumValues) {
    return item.enumValues.map((value) => [value, value]);
  }
  return [];
};

const getTreeData = (fieldName: string) => {
  const item = fieldTypeMap.value.get(fieldName);
  if (!item) {
    return [];
  }
  return item.treeData || [];
};

const addRow = () => {
  defineConds.value.push({ name: "", operator: "", value1: "", value2: "" });
};

const deleteRow = () => {
  if (defineConds.value.length > 3) {
    defineConds.value.pop();
  }
};

const execCondRelation = () => {
  const condArr: Array<string> = [];
  defineConds.value.forEach((cond, index) => {
    if (!cond || isEmptyOrWhiteSpace(cond.name)) {
      return;
    }
    condArr.push((index + 1).toString());
  });
  condRelation.value = condArr.join(" and ");
};

const onFieldChange = (cond: CondItem) => {
  cond.value1 = "";
  cond.value2 = "";
  cond.operator = "";
  if (!isEmptyOrWhiteSpace(cond.name)) {
    const opers = getCondOperators(cond.name);
    if (opers.length) {
      cond.operator = opers[0][0];
    }
  }
  execCondRelation();
};

const onOperatorChange = (cond: CondItem) => {
  cond.value1 = "";
  cond.value2 = "";
};

const validateCond = () => {
  return true;
};

const getSearchData = () => {
  if (!validateCond()) {
    return null;
  }
  const cond: CondObject = { items: [], relation: "" };
  if (!defineConds.value.length) {
    return cond;
  }
  cond.relation = condRelation.value;
  const defs: Array<CondItem> = JSON.parse(JSON.stringify(defineConds.value));
  defs.forEach((item) => {
    if (isEmptyOrWhiteSpace(item.name)) {
      return;
    }
    if (isEmptyOrWhiteSpace(item.operator)) {
      if (item.value1 instanceof Array) {
        item.operator = CondOperator.BETWEEN;
      } else {
        item.operator = CondOperator.GT;
      }
    }
    if (item.value1 instanceof Array) {
      const field = fieldTypeMap.value.get(item.name);
      if (!field) {
        return;
      }
      const arr = item.value1;
      if (field.type === "date") {
        item.value1 = arr[0];
        item.value2 = arr[1];
      } else if (field.type === "enum") {
        item.value1 = item.value1.join(",");
      } else if (field.type === "tree") {
        item.value1 = item.value1.map((data) => data.join("/")).join(",");
      }
    }
    cond.items.push(item);
  });
  return JSON.stringify(cond);
};

expose({ getSearchData });

return { __sfc: true,props, store, defineConds, condRelation, initCondObjectCount, fieldTypeMap, allFields, groupedFields, condOpers, getCondOperators, getFieldType, getEnumData, getTreeData, addRow, deleteRow, execCondRelation, onFieldChange, onOperatorChange, validateCond, getSearchData }
}

})